module.exports = __webpack_public_path__ + "img/introduce-5.0978c7d5.png";